"use client";
import React from "react";
import { Suspense } from "react";
import styles from "../getting-the-basis-of-advice-right-page/getting-the-basis-of-advice-right-page.module.css";
import "../../../src/common/grid.css";
import BlogNavigation from "../../../components/BlogNavigation/BlogNavigation";
import BlogSearchSection from "../../../components/BlogSearchSection/BlogSearchSection";
import Disclaimer from "../../../components/BlogDiclaimerComponent/BlogDisclaimerComponent";
import Link from "next/link";
import BlogCardSlider from "../../../components/BlogCardSlider/BlogCardSlider";
import { useTranslation } from "react-i18next";
import BlogSpreadLoveComponent from "../../../components/BlogSpreadLoveComponent/BlogSpreadLoveComponent";
import BlogStartSection from "../../../components/BlogStartSection/BlogStartSection";
import BlogLeaveReplyComponent from "../../../components/BlogLeaveReplyComponent/BlogLeaveReplyComponent";
import { usePosts } from "../../../src/app/blogs/posts.js";
import howMuchDoesItCostToBuyProperty from "../../../src/assets/images/howMuchDoesItCostToBuyProperty.webp";
 

export default function HowMuchDoesItCostToBuyProperty() {
    const { t } = useTranslation();
    const posts = usePosts();
    // Blog metadata
    const blogData = {
        categorySlug: "insights",
        image: howMuchDoesItCostToBuyProperty,
        category: t("Insights"),
        relatedCategory: "insights",
        title: t("How Much Does it Really Cost to Buy Property?"),
        url: "/blogs/how-much-does-it-really-cost-to-buy-property",
        slug: "how-much-does-it-really-cost-to-buy-property/",
        author: "Matthew Clark",
    };

    const relatedPosts = posts
        .filter(
            (post) =>
                post.relatedCategory === blogData.relatedCategory && post.slug !== blogData.slug
        )
        .slice(0, 10);

    return (
        <>
            <div className={styles.blogWrapper}>
                <div className={`${styles.flexContainer} container`}>
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-8">
                            <div className={styles.blogContentWrapper}>
                                <BlogNavigation
                                    items={[
                                        { title: t("Key Choice Lending"), path: "/" },
                                        { title: t("Blogs"), path: "/blogs" },
                                        {
                                            title: blogData.category,
                                            path: `/blogs/category/${blogData.categorySlug}`,
                                        },
                                    ]}
                                    currentPageTitle={blogData.title}
                                />
                                <BlogStartSection
                                    title={blogData.title}
                                    author={blogData.author}
                                    category={blogData.relatedCategory}
                                    image={howMuchDoesItCostToBuyProperty}
                                    alt={t("how-much-does-it-cost-to-buy-property-image")}
                                />
                                <BlogSpreadLoveComponent url={blogData.url} title={blogData.title} />
                                <article className={styles.blogContent}>
                                    <p className={styles.small}>
                                        {t("As if keeping track of the property market wasn’t a full-time job in itself! When you buy a property, it’s more than just the advertised price you’ll need to factor into your plans.")}
                                    </p>
                                    <p className={styles.small}>
                                        <strong>{t("Home loan application fees")}</strong>
                                    </p>
                                    <p className={styles.small}>
                                        {t("There’s no such thing as a free lunch, and many lenders charge you a fee for the privilege of applying for a home loan. Part of their rationale is presumably to cover the costs of processing your application, as well as it acting as a deterrent from applying with multiple lenders (which would impact your credit rating). An application fee covers:")}
                                    </p>
                                    <p className={styles.small}>
                                        <ul>
                                            <li>{t("Credit checks")}</li>
                                            <li>{t("Title checks")}</li>
                                            <li>{t("Contracts")}</li>
                                            <li>{t("Contracts")}</li>
                                        </ul>
                                    </p>
                                    <p className={styles.small}>
                                        <strong>{t("But wait, there’s more!")}</strong>
                                    </p>
                                    <p className={styles.small}>
                                        <ul>
                                            <li>
                                                {t("Establishment fees – This is a fee for setting up the mortgage (not to be confused with the application fee).")}
                                            </li>
                                            <li>
                                                {t("Property valuation – The lender will assign a property valuer to assess how much your property is really worth.")}
                                            </li>
                                            <li>
                                                {t("Mortgage registration – Your mortgage deed must be registered with the government.")}
                                            </li>
                                            <li>
                                                {t("Lenders mortgage insurance – If you’re applying for a loan without at least a 20% deposit, you may have to pay for an insurance that protects the lender on the off chance you stop making repayments.")}
                                            </li>
                                            <li>
                                                {t("Stamp Duty – Most State Governments charge stamp duty, however good news is in an attempt to stimulate the economy, many states are reducing or waiving stamp duty altogether.")} <Link href="/booking">{t("Get in touch")}</Link> {t("to find out more.")}
                                            </li>
                                        </ul>
                                    </p>
                                    <p className={styles.small}>
                                        <strong>{t("…And there’s still more!")}</strong>
                                    </p>
                                    <p className={styles.small}>
                                        <ul>
                                            <li>
                                                {t("Building inspector – If you don’t check whether your prospective purchase is structurally sound and safe from termites, then good luck to you!")}
                                            </li>
                                            <li>
                                                {t("Registration of transfer – You’ll need to register your ownership at the Land Titles Office.")}
                                            </li>
                                            <li>
                                                {t("Conveyancing – You’ll need to engage a conveyancer to handle the transfer of ownership of the property on your behalf.")}
                                            </li>
                                            <li>
                                                {t("Home insurance – Now that you’re a homeowner you’ll need to insure the property (not just your contents, like when you were renting). In fact, the lender will likely insist on it.")}
                                            </li>
                                            <li>
                                                {t("Utility costs – There may be fees to setup your electricity, gas and internet connection.")}
                                            </li>
                                            <li>
                                                {t("Life and income protection insurance – Now that you’ve committed to a home loan, it’s worth considering how you or your family would continue repayments if something were to happen.")}
                                            </li>
                                            <li>
                                                {t("Council Rates – Your local council will charge you rates to cover roads, rubbish and other maintenance costs.")}
                                            </li>
                                            <li>
                                                {t("Body corporate fees – If your property is on strata title, you may need to pay body corporate fees. These can be pretty substantial, depending on the features of the communal space and the age of the property.")}
                                            </li>
                                            <li>
                                                {t("If you want help applying for finance,")} <Link href="/booking">{t("book a meeting")}</Link> {t("with us today.")}
                                            </li>
                                        </ul>
                                    </p>
                                </article>
                                <BlogSpreadLoveComponent url={blogData.url} title={blogData.title} />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className={styles.searchSection}>
                                <Suspense>
                                    <BlogSearchSection />
                                </Suspense>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.BlogCardSliderWrapper}>
                    <div className="container">
                        <div className={styles.BlogCardSliderContent}>
                            <BlogCardSlider posts={relatedPosts} />
                        </div>
                    </div>
                </div>
                <div className={styles.leaveReplyWrapper}>
                    <div className="container">
                        <div className={styles.leaveReplyContent}>
                            <BlogLeaveReplyComponent />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}